module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xLjM3NSAxMy4zNjIzTDcuMzc1IDcuMzYyMzFMMTMuMzc1IDEzLjM2MjNNMTMuMzc1IDEuMzYyM0w3LjM3Mzg2IDcuMzYyMzFMMS4zNzUgMS4zNjIzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/closeLastWeek.svg
// module id = DXG6
// module chunks = 0